import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirectUpdateRequestLegacy, LocationInventorySummary } from '../../models';

@Component({
  selector: 'app-adjust-inventory-modal',
  templateUrl: './adjust-inventory-modal.component.html',
  styleUrls: ['./adjust-inventory-modal.component.scss']
})
export class AdjustInventoryModalComponent implements OnInit {
  @Input() locations: LocationInventorySummary[] = [];
  @Input() selectedLocation: LocationInventorySummary | null = null;
  @Output() onSubmit = new EventEmitter<DirectUpdateRequestLegacy>();
  @Output() onCancel = new EventEmitter<void>();

  adjustForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.adjustForm = this.fb.group({
      locationId: [this.selectedLocation?.locationId || null, Validators.required],
      matType: ['Wood', Validators.required],
      bucketCd: ['Available', Validators.required],
      quantity: [null, [Validators.required, Validators.min(1)]],
      action: ['Add', Validators.required]
    });
  }

  get locationId() { return this.adjustForm.get('locationId'); }
  get matType() { return this.adjustForm.get('matType'); }
  get bucketCd() { return this.adjustForm.get('bucketCd'); }
  get quantity() { return this.adjustForm.get('quantity'); }
  get action() { return this.adjustForm.get('action'); }

  submit(): void {
    if (this.adjustForm.valid) {
      const request: DirectUpdateRequestLegacy = {
        locationId: this.adjustForm.value.locationId,
        matType: this.adjustForm.value.matType,
        bucketCd: this.adjustForm.value.bucketCd,
        quantity: this.adjustForm.value.quantity,
        action: this.adjustForm.value.action,
        createdBy: '' // Will be set by parent component
      };
      this.onSubmit.emit(request);
    }
  }

  cancel(): void {
    this.onCancel.emit();
  }
}
